// Notify Me — Back in Stock
// Hooks into Dawn's variantChange pub/sub event so the form shows/hides
// correctly whenever the customer switches variants.
//
// Replace the two constants below with your store values before going live.

const STOREFRONT_API_URL = 'https://YOUR-STORE.myshopify.com/api/2024-01/graphql.json';
const STOREFRONT_TOKEN   = 'YOUR_PUBLIC_STOREFRONT_TOKEN';

const MUTATION = `
  mutation subscribeToBackInStockNotification($email: String!, $variantId: ID!) {
    subscribeToBackInStockNotification(email: $email, variantId: $variantId) {
      userErrors { field message }
    }
  }
`;

// ─── Show / hide helpers ──────────────────────────────────────────────────────

function showNotifyBlock(block, variantId) {
  block.dataset.variantId = variantId;
  block.hidden = false;
}

function hideNotifyBlock(block) {
  block.hidden = true;
}

function resetNotifyBlock(block) {
  block.querySelector('.notify-me__field').hidden               = false;
  block.querySelector('.notify-me__btn').hidden                 = false;
  block.querySelector('.notify-me__message--success').hidden    = true;
  block.querySelector('.notify-me__message--error').hidden      = true;
  const input = block.querySelector('.notify-me__input');
  input.removeAttribute('aria-invalid');
}

// ─── Subscribe to Dawn's variantChange pub/sub ────────────────────────────────
// product-info.js publishes this whenever the customer picks a different variant.

subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { sectionId, variant } }) => {
  // Find the notify block for this section
  const block = document.querySelector(`.notify-me[data-section="${sectionId}"]`);
  if (!block) return;

  resetNotifyBlock(block);

  if (!variant || !variant.available) {
    // Unavailable or sold-out variant — show the form
    showNotifyBlock(block, variant?.id || '');
  } else {
    // Back in stock — hide the form
    hideNotifyBlock(block);
  }
});

// ─── Form submission ──────────────────────────────────────────────────────────

function initNotifyMe() {
  document.querySelectorAll('.notify-me').forEach((block) => {
    const form      = block.querySelector('.notify-me__form');
    const input     = block.querySelector('.notify-me__input');
    const submitBtn = block.querySelector('.notify-me__btn');
    const successMsg = block.querySelector('.notify-me__message--success');
    const errorMsg   = block.querySelector('.notify-me__message--error');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const email     = input.value.trim();
      const variantId = `gid://shopify/ProductVariant/${block.dataset.variantId}`;

      // Reset state
      input.removeAttribute('aria-invalid');
      successMsg.hidden = true;
      errorMsg.hidden   = true;

      // Validate
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }

      submitBtn.disabled    = true;
      submitBtn.classList.add('is-loading');
      submitBtn.textContent = 'Submitting…';

      try {
        const res = await fetch(STOREFRONT_API_URL, {
          method:  'POST',
          headers: {
            'Content-Type':                      'application/json',
            'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
          },
          body: JSON.stringify({
            query:     MUTATION,
            variables: { email, variantId },
          }),
        });

        const { data, errors } = await res.json();
        const userErrors = data?.subscribeToBackInStockNotification?.userErrors ?? [];

        if (errors?.length || userErrors.length) {
          throw new Error(userErrors[0]?.message || 'GraphQL error');
        }

        block.querySelector('.notify-me__field').hidden = true;
        submitBtn.hidden  = true;
        successMsg.hidden = false;

      } catch (err) {
        console.error('[notify-me]', err);
        errorMsg.hidden       = false;
        submitBtn.disabled    = false;
        submitBtn.classList.remove('is-loading');
        submitBtn.textContent = 'Notify me';
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initNotifyMe);
